import React from "react";
import { Link, NavLink } from "react-router-dom";
import "./Header.css";

const Header = () => {
  return (
    <div className=" bg-slate-100  h-20 drop-shadow-lg">
      <div className="flex justify-between items-center">
        <div className="header">
          <Link to="/">
            <h2 className="text-3xl font-bold text-sky-500 mt-6 ml-20">
              Quick Quiz
            </h2>
          </Link>
        </div>
        <div className=" mr-20 mt-6 header-links">
          <NavLink className="mr-6 font-bold" to="/">
            Topics
          </NavLink>
          <NavLink className="mr-6 font-bold" to="/statistics">
            Statistics
          </NavLink>
          <NavLink className="font-bold" to="/blog">
            Blog
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default Header;
